import React from 'react';
import { prop } from 'ramda';
import * as urlUtil from '@theme/js/utils/url.util';
import { useAppSelector } from '@core/js/store/hooks';
import { BackboneReplacer } from '@theme/js/backbone/components/BackboneReplacer';
import { useTranslations } from '@core/js/hooks/i18n';
import { Link } from '@theme/js/components/common/Link';

import { MyAccount } from '../MyAccount';
import { MyBalance } from '../MyBalance';
import { Inbox } from '../Inbox';

import style from './UserInfoSection.scss';

export const UserInfoSection: React.FC = () => {
    const translate = useTranslations();
    const inboxWidget = useAppSelector(prop('inboxWidget'));
    const hideInboxByUrl = urlUtil.getLocationParam('hideInbox') === '1';
    const showInbox = inboxWidget.showIcon && inboxWidget.enabled && !hideInboxByUrl;

    return (
        <div className={style.container}>
            {/* User section */}
            <MyAccount />

            <div className={style.infoBlock}>
                <div className={`${style.infoBlockSettings} ${!showInbox ? style.hideInbox : ''}`}>
                    {/* Inbox section */}
                    {showInbox &&
                        <div className={style.infoSettingsItem}>
                            <Inbox/>
                        </div>
                    }

                    {/* Favorite section */}
                    <div className={style.infoSettingsItem}>
                        <Link href={translate('playtech.mobile.system.header.favoriteBtn.link')}
                           className={`${style.favoriteLink}`}
                           aria-label={translate('playtech.mobile.system.header.favoriteBtn.label')}
                        >
                            <span className={`${style.favoriteLinkIcon} icon-ico-s4w-favorite`} />
                        </Link>
                    </div>

                    {/* Bonus section */}
                    <div className={style.infoSettingsItem}>
                        <Link href={translate('playtech.mobile.system.header.bonusBtn.link')}
                           className={`${style.bonusLink}`}
                           aria-label={translate('playtech.mobile.system.header.bonusBtn.label')}
                        >
                            <span className={`${style.bonusLinkIcon} icon-ico-s4w-gift`} />
                        </Link>
                    </div>
                </div>
                <div className={style.infoBlockBalance}>
                    <MyBalance/>
                </div>

                <div className={style.deposit}>
                    <BackboneReplacer
                            dynamicName="HEADER_DEPOSIT_BUTTON"
                            viewName="headerdepositbutton"
                            isHideBackboneClass={true}
                    />
                </div>
            </div>
        </div>
    );
};
